/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGlobalRemoteSessionIssuerDuplicatePreflightRequest = {
  /**
   * The upstream issuer URL being entered (e.g. https://login.linear.app). Empty or unparseable returns no matches.
   */
  issuer?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity$Outbound,
    GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getGlobalRemoteSessionIssuerDuplicatePreflightSecurityToJSON(
  getGlobalRemoteSessionIssuerDuplicatePreflightSecurity:
    GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity$outboundSchema.parse(
      getGlobalRemoteSessionIssuerDuplicatePreflightSecurity,
    ),
  );
}

/** @internal */
export type GetGlobalRemoteSessionIssuerDuplicatePreflightRequest$Outbound = {
  issuer?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionIssuerDuplicatePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetGlobalRemoteSessionIssuerDuplicatePreflightRequest$Outbound,
    GetGlobalRemoteSessionIssuerDuplicatePreflightRequest
  > = z.pipe(
    z.object({
      issuer: z.optional(z.string()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function getGlobalRemoteSessionIssuerDuplicatePreflightRequestToJSON(
  getGlobalRemoteSessionIssuerDuplicatePreflightRequest:
    GetGlobalRemoteSessionIssuerDuplicatePreflightRequest,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionIssuerDuplicatePreflightRequest$outboundSchema.parse(
      getGlobalRemoteSessionIssuerDuplicatePreflightRequest,
    ),
  );
}
